// extracted by mini-css-extract-plugin
export default {"placeholder":"StoryCardMediaPlaceholder_placeholder__dFAFe","placeholder__icon":"StoryCardMediaPlaceholder_placeholder__icon__Qzah3"};